import { Injectable } from '@angular/core';

import { UsersService } from '@shared/api';
import { Users } from '@shared/api/users/users.model';
import { AuthService } from '../auth/auth.service';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private userInfo: Users = null;

  constructor(
    private _sessionStorageService: SessionStorageService,
    private _users: UsersService
  ) {}

  public getUserInfo(): Users {
    return this.userInfo;
  }

  loanUserInfo() {
    return new Promise((resolve, reject) => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.isLogin) {
        this._users.getUserInfo(currentUser.username).subscribe(
          res => {
            this.userInfo = res;
            resolve(true);
          },
          () => {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('part_jwt');
            this._sessionStorageService.removeSession(`EAC`);
            resolve(true);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  clearInfo() {
    this.userInfo = null;
  }
}
